import { render, staticRenderFns } from "./xfsbList.vue?vue&type=template&id=0fcf573c&scoped=true&"
import script from "./xfsbList.vue?vue&type=script&lang=js&"
export * from "./xfsbList.vue?vue&type=script&lang=js&"
import style0 from "./xfsbList.vue?vue&type=style&index=0&id=0fcf573c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf573c",
  null
  
)

export default component.exports